import React from 'react';
import { observer } from 'mobx-react';
import './Channel.less';
import autobind from 'autobind-decorator';
import Swiper from '../../com/swiper-3.3.1.min';
import '../../com/swiper-3.3.1.min.css';
import store from '../../store';

interface ChannelState {
    isShow: any;
}

interface ChannelPropType {
    prefixCls?: string;
    tabArrList?: any[];
    onChannelClick?: any;
    isShowFloor?: any
    style?: any;
}

@observer
class Channel extends React.Component<ChannelPropType, ChannelState> {
    static defaultProps = {
        prefixCls: 'Channel',
    };

    constructor(props, context) {
        super(props, context);
        this.state = {
            isShow: 1
        };
    }

    swiper: any;
    itemNav = (id) => {
        let current = store.classification.channelState;
        return id == current ? 'swiper-slide active' : 'swiper-slide';

    };

    @autobind
    onHomeClick() {
        const {isShow} = this.state;
        let current = store.classification.channelState;
        if (isShow === 1 && current) {
            this.setState(
                {
                    isShow: 2
                }
            );
        } else if (this.state.isShow === 2) {
            this.setState({
                isShow: 1
            });
            store.classification.setChannelSate('channel');
            // 记录初始位置
            store.classification.setInitialSlide(0);
        }
        this.props.onChannelClick();
    }

    @autobind
    onTabClick(item, index) {
        this.setState({
            isShow: 2
        });
        store.classification.setChannelSate(item.id);
        // 记录初始位置
        store.classification.setInitialSlide(index);
        this.props.onChannelClick(item);
    }

    componentWillMount() {
        let channelState = store.classification.channelState;
        channelState && channelState != 'channel' && channelState != 'initial' && this.setState({
            isShow: 2
        });
    }

    componentDidMount() {
        // 是否点击首页
        let initialSlide = store.classification.initialSlide;
        this.swiper = new Swiper(
            '#topNav', {
                initialSlide: initialSlide,
                freeMode: true,
                freeModeMomentumRatio: 0.5,
                slidesPerView: 'auto',
                observer: true, // 修改swiper自己或子元素时，自动初始化swiper
                observeParents: true,// 修改swiper的父元素时，自动初始化swiper
            }
        );
    };

    render() {
        const {prefixCls, tabArrList, style} = this.props;
        const {isShow} = this.state;
        let active: any = isShow == 1 ? ` active` : ``;
        return (
            <div id="topNav" className={`swiper-container ${prefixCls}-swipper`} style={style}>
                <div className="swiper-wrapper">
                    <div className={'swiper-slide' + active} onClick={this.onHomeClick}>
                        推荐
                        {isShow === 1 && <span className={`${prefixCls}-swiperLine`}/>}
                    </div>
                    {
                        tabArrList && tabArrList.map((item, index) => {
                            return (
                                <div key={index} className={this.itemNav(item.id)} data-i={index} onClick={() => {
                                    this.onTabClick(item, index);
                                }}>
                                    {item.name}
                                    {item.id == store.classification.channelState &&
                                    <span className={`${prefixCls}-swiperLine`}/>}
                                </div>
                            );
                        })
                    }
                </div>
            </div>
        );
    }
}

export default Channel;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/widgets/channel/Channel.tsx